export default "__VITE_ASSET__CKOYR7bE__"